export const MASK = {
  PHONE: "(000) 000-0000",
  PHONE_LAST_4: "0000",
  ZIP: "00000",
  SSN: "000-00-0000",
  SSN_HIDDEN: "XXX-XX-0000",
  TIME: "00:00 SS",
  TWO_FACTOR: "0 0 0 0 0 0",
  HEIGHT: "0'09"
};
